import { head } from 'framer-motion/client';
import { generateSectionId } from '../../../HelpCenterComponents/ArticleLayout';

export const PartnershipContentBody = ({ activeLeft }) => {
  const contentData = {
    0: {
      sections: [
        {
          type: 'text',
          heading: 'Spatial Grid Partner Ecosystem',
          paragraphs: [
            'At Spatial Grid, we believe that transformative, enterprise-scale innovation is best delivered through strong, trusted partnerships. Our Partner Ecosystem is designed to empower system integrators, consulting firms, technology partners, and domain specialists to jointly deliver high-quality, future-ready immersive and spatial intelligence solutions to customers across industries.',
            'By partnering with Spatial Grid, organizations gain access to a robust Spatial Intelligence Platform powered by Immersive Spatial Models (ISMs)—enabling them to design, deploy, and scale AR, VR, MR, simulation, and GIS-enabled experiences with enterprise-grade reliability.',
          ],
        },
      ],
    },
    1: {
      sections: [
        {
          type: 'text',
          heading:
            'Go-To-Market (GTM) Partnership Aligned to Industry Verticals',
          paragraphs: [
            'Spatial Grids Go-To-Market (GTM) Partnership Program is strategically aligned with our industry-vertical strategy, enabling partners to deliver deeply contextual, scalable, and high-impact spatial intelligence solutions across a wide range of sectors. Our GTM framework ensures that system integrators and consulting partners can address domain-specific challenges with precision, speed, and measurable business outcomes.',
          ],
        },
        {
          type: 'text',
          paragraphs: [
            'We actively collaborate with partners across the following key verticals:',
          ],
        },
        {
          type: 'list',
          items: [
            {
              title: 'Pharmaceuticals & Life Sciences',
              description:
                'Immersive safety training, SOP-driven simulations, digital twins of manufacturing facilities, compliance enablement, operator certification, and risk-reduction programs.',
            },
            {
              title: 'Defence & Aerospace',
              description:
                'Mission rehearsal systems, simulator-based training, spatial intelligence platforms, geofenced operational environments, and high-fidelity immersive experiences for readiness and decision-making.',
            },
            {
              title: 'Education & Training',
              description:
                'Immersive learning platforms, virtual labs, skills-based training simulations, workforce upskilling, institutional training modules, and experiential education powered by spatial intelligence.',
            },
            {
              title: 'Tourism & Cultural Experiences',
              description:
                'Virtual destination experiences, heritage preservation, immersive storytelling, AR-guided tours, and interactive visitor engagement platforms for tourism boards and cultural institutions.',
            },
            {
              title: 'Automotive & Transportation',
              description:
                'Driver and operator training simulators, vehicle familiarization, safety training, maintenance simulations, logistics visualization, and spatial intelligence solutions for mobility ecosystems.',
            },
            {
              title: 'Architecture, Engineering & Real Estate (AEC)',
              description:
                'XR-based design visualization, interactive building models, spatial walkthroughs, construction planning, stakeholder collaboration, and immersive sales and marketing experiences.',
            },
            {
              title: 'Energy & Mining',
              description:
                'Driver and operator training simulators, vehicle familiarization, safety training, maintenance simulations, logistics visualization, and spatial intelligence solutions for mobility ecosystems.',
            },
          ],
        },
        {
          type: 'text',
          paragraphs: [
            'This verticalized GTM approach enables partners to deliver faster time-to-value, ensure domain-aligned best practices, and drive superior outcomes for enterprise customers across industries.',
          ],
        },
      ],
    },
    2: {
      intro:
        'Spatial Grids partner program supports multiple commercial engagement models, enabling partners to build sustainable revenue streams:',
      sections: [
        {
          type: 'list',
          heading:
            'Flexible Commercial Models: License Sales & Consulting Engagements',
          items: [
            {
              title: 'Platform License Sales',
              description:
                'Resell or co-sell Spatial Grids enterprise platform, engines, and modules to customers.',
            },
            {
              title: 'Consulting & Solution Sales',
              description:
                'Design, customize, and implement immersive solutions using Spatial Grids technology stack.',
            },
            {
              title: 'Joint GTM & Co-Innovation',
              description:
                'Collaborate on large enterprise programs, proof-of-concepts, pilots, and long-term digital transformation initiatives.',
            },
          ],
        },
        {
          type: 'text',
          paragraphs: [
            'Our flexible models allow partners to position themselves as trusted advisors and solution owners, while leveraging Spatial Grids technology, IP, and platform capabilities.',
          ],
        },
      ],
    },
    3: {
      intro:
        'All Spatial Grid partnership agreements are structured with a strong emphasis on governance, transparency, and compliance.',
      sections: [
        {
          type: 'text',
          heading: 'Partnership Agreements Built on Global Best Practices',
          paragraphs: [
            'Our agreements are aligned with global corporate standards, including:',
          ],
        },
        {
          type: 'list',
          items: [
            {
              title:
                'Clearly defined roles, responsibilities, and engagement frameworks',
              description: '',
            },
            {
              title: 'Adherence to anti-bribery and anti-corruption policies',
              description: '',
            },
            {
              title:
                'Compliance with applicable international corporate, ethical, and legal standards',
              description: '',
            },
            {
              title:
                'Commitment to data protection, information security, and responsible AI practices',
              description: '',
            },
            {
              title:
                'Alignment with industry-specific certifications and regulatory requirements, where applicable',
              description: '',
            },
          ],
        },
        {
          type: 'text',
          paragraphs: [
            'These principles ensure long-term trust, risk mitigation, and credibility—especially when operating in highly regulated sectors such as Pharma, Defence, and Aerospace.',
          ],
        },
      ],
    },
    4: {
      sections: [
        {
          type: 'list',
          heading: 'Why Partner with Spatial Grid',
          items: [
            'Access to a cutting-edge Spatial Intelligence & Immersive Tech Platform',
            'Industry-aligned GTM strategy and sales enablement',
            'Strong focus on quality, scalability, and enterprise readiness',
            'Compliance-driven partnership frameworks',
          ],
        },
      ],
    },
    5: {
      sections: [
        {
          type: 'text',
          heading: 'Partner With Us',
          paragraphs: [
            'If you are a system integrator, consulting firm, or technology partner looking to deliver differentiated, high-impact immersive solutions to enterprise customers, we invite you to explore a partnership with Spatial Grid.',
            'Reach out to us to learn more about our partnership programs, engagement models, and collaboration opportunities.',
          ],
        },
      ],
    },
  };

  const currentContent = contentData[activeLeft] || contentData[0];

  return (
    <div className="text-[#FFFFFF]">
      {currentContent?.intro && (
        <p className="font-light font-jakarta text-[15px] leading-relaxed mb-8">
          {currentContent.intro}
        </p>
      )}

      {currentContent?.sections?.map((section, index) => {
        const sectionId = section?.heading
          ? generateSectionId(section.heading)
          : null;

        return (
          <div key={index} className="mb-10">
            {/* Heading (if exists) */}
            {section?.heading && (
              <h2
                id={sectionId}
                className="text-[22px] font-medium text-[#D8D8D8] mb-4 scroll-mt-28"
              >
                {section.heading}
              </h2>
            )}

            {/* 🔹 TEXT SECTION */}
            {section?.type === 'text' &&
              section?.paragraphs?.map((paragraph, pIndex) => (
                <p
                  key={pIndex}
                  className="font-light text-[15px] leading-relaxed mb-4 text-[#E4E4E4]"
                >
                  {paragraph}
                </p>
              ))}

            {/* 🔹 SIMPLE LIST (strings only) */}
            {/* SIMPLE LIST (strings only) */}
            {section?.type === 'list' &&
              section?.items &&
              Array.isArray(section.items) &&
              section.items.length > 0 &&
              typeof section.items[0] === 'string' && (
                <ul className="list-disc list-inside space-y-3 text-[15px] font-light text-[#E4E4E4]">
                  {section.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              )}

            {/* DETAILED LIST (objects with title/description) */}
            {section?.type === 'list' &&
              section?.items &&
              Array.isArray(section.items) &&
              section.items.length > 0 &&
              typeof section.items[0] === 'object' && (
                <ul className="list-disc list-inside space-y-4 text-[15px] text-[#E4E4E4]">
                  {section.items.map((item, i) => (
                    <li key={i} className="font-light">
                      <span className="font-semibold text-white">
                        {item?.title}
                      </span>
                      {item?.description && (
                        <span className="font-light">
                          {' '}
                          – {item.description}
                        </span>
                      )}
                    </li>
                  ))}
                </ul>
              )}
          </div>
        );
      })}
    </div>
  );
};
